// Centralized test-environment helpers
// Allows selective use of process.env behind a single, linter-exempt boundary.

type VitestEnv = Record<string, string> & {
  VITEST?: string;
  VITEST_FAST_URL_RESOLUTION?: string;
  PLAYWRIGHT_TEST?: string;
  NEXT_PUBLIC_PLAYWRIGHT_TEST?: string;
  PLAYWRIGHT_BASE_URL?: string;
  PLAYWRIGHT_MOCK_AUTH?: string;
};

const isTruthyFlag = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
};

export function isVitest(): boolean {
  // Access directly for test runners; isolated to this file by lint override.
  try {
    // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion
    const nodeProcess = (globalThis as { process?: { env?: VitestEnv } }).process;
    const envMap = nodeProcess?.env;
    return Boolean(envMap?.VITEST);
  } catch {
    return false;
  }
}

export function isVitestFastUrlResolution(): boolean {
  try {
    // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion
    const nodeProcess = (globalThis as { process?: { env?: VitestEnv } }).process;
    const envMap = nodeProcess?.env;
    return envMap?.VITEST_FAST_URL_RESOLUTION === 'true';
  } catch {
    return false;
  }
}

export function isPlaywrightTestEnv(): boolean {
  try {
    // oxlint-disable-next-line typescript-eslint/no-unsafe-type-assertion
    const nodeProcess = (globalThis as { process?: { env?: VitestEnv } }).process;
    const envMap = nodeProcess?.env;
    const playwrightFlag = isTruthyFlag(envMap?.PLAYWRIGHT_TEST) || isTruthyFlag(envMap?.NEXT_PUBLIC_PLAYWRIGHT_TEST);
    if (!playwrightFlag) {
      return false;
    }

    const hasPlaywrightBaseUrl =
      typeof envMap?.PLAYWRIGHT_BASE_URL === 'string' && envMap.PLAYWRIGHT_BASE_URL.trim().length > 0;
    const isMockAuth = isTruthyFlag(envMap?.PLAYWRIGHT_MOCK_AUTH);

    return hasPlaywrightBaseUrl || isMockAuth;
  } catch {
    return false;
  }
}
